import React from 'react'
import { useSearchParams } from 'react-router-dom'

import SelectBox from '@/compoments/common/SelectBox'
import SelectBoxAsynk from '@/compoments/common/SelectBoxAsynk'
import {
    useLazyGetAllCertificatesQuery,
    useLazyGetAllSkilsQuery,
} from '@/services/other/other'
import { optionsRating, optionsTeamStatus } from '@/utils/selectsOptionsConst'

const Filters = () => {
    const [searchParams, setSearchParams] = useSearchParams()
    const filterHandler = (
        name: string,
        value: string | number | undefined,
    ) => {
        setSearchParams((prev: URLSearchParams) => {
            prev.set('page', '1')
            if (value) {
                prev.set(name, String(value))
            } else {
                prev.delete(name)
            }
            return prev
        })
    }

    const [getSkills] = useLazyGetAllSkilsQuery()
    const [getCertificates] = useLazyGetAllCertificatesQuery()
    const loadOptionsSkills = async (
        search: string,
        loadedOptions: any,
        { page }: { page: number },
    ) => {
        const res = await getSkills(`page=${page}&search=${search}`).unwrap()

        return {
            options:
                res?.data.map((skill) => ({
                    value: skill.id,
                    label: skill.name,
                })) || [],
            hasMore: page != res?.pagination?.maxPages, // флаг, показывающий, есть ли еще данные
            additional: {
                page: page + 1, // увеличиваем номер страницы для следующего запроса
            },
        }
    }

    const loadOptionsCertificates = async (
        search: string,
        loadedOptions: any,
        { page }: { page: number },
    ) => {
        const res = await getCertificates(
            `page=${page}&search=${search}`,
        ).unwrap()

        return {
            options:
                res?.data.map((skill) => ({
                    value: skill.id,
                    label: skill.name,
                })) || [],
            hasMore: page != res?.pagination?.maxPages, // флаг, показывающий, есть ли еще данные
            additional: {
                page: page + 1, // увеличиваем номер страницы для следующего запроса
            },
        }
    }

    return (
        <div className="table-tools">
            <SelectBoxAsynk
                wrapperClassName="select--outline input--sm"
                placeholder="Skills"
                fetchFunk={loadOptionsSkills}
                onChange={(option) => filterHandler('skills', option?.label)}
                isClearable
            />
            <SelectBoxAsynk
                wrapperClassName="select--outline input--sm"
                placeholder="Certificates"
                fetchFunk={loadOptionsCertificates}
                onChange={(option) =>
                    filterHandler('certificates', option?.label)
                }
                isClearable
            />
            <SelectBox
                wrapperClassName="select--outline input--sm"
                placeholder="Status"
                options={optionsTeamStatus}
                onChange={(option) => filterHandler('status', option?.value)}
                isClearable
            />
            <SelectBox
                wrapperClassName="select--outline input--sm"
                placeholder="Rating"
                options={optionsRating}
                onChange={(option) => filterHandler('rating', option?.value)}
                isClearable
            />
            <SelectBox
                wrapperClassName="select--outline input--sm"
                placeholder="Jobs Completed"
                options={[]}
                isClearable
            />
        </div>
    )
}

export default Filters
